import React from "react";

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      onClick={handleBackdropClick}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    >
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative"
        onClick={(e) => e.stopPropagation()} // 🔥 VERY IMPORTANT
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 text-gray-500 right-3 text-gray-500 hover:text-black"
        >
          ✕
        </button>

        {/* Title */}
        {title && (
          <h2 className="text-[1rem] text-gray-800 font-bold mb-4">{title}</h2>
        )}
        <hr />
        {/* Modal Content */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
